import { toArray } from '~/utils/commonUtils';

function setSizesForColor(latchkeyColorMap, cb) {
  toArray(latchkeyColorMap).forEach(({ key, value: colors }) => {
    colors.colorArray.forEach((color) => {
      color.sizes = cb(key, color);
    });
  });
}

export default function parser(latchkeyColorMap, latchkeySizeMap) {
  setSizesForColor(latchkeyColorMap, (latchkeyName, color) => {
    const typeToColor = [];
    latchkeySizeMap[latchkeyName].sizeArray.forEach((size) => {
      typeToColor[size.id] = { id: size.id, colors: Object.keys(size.colorToSizes).map((colorId) => Number(colorId)) };
    });

    return typeToColor
      .filter((typeColor) => typeColor.colors.includes(color.id))
      .map((typeColor) => typeColor.id)
      .flat();
  });
}
